import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, Button, Spinner, Badge } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalSeguroCancelarSuscripcion = ({
    show,
    onClose,
    onConfirm,
    processing,
    suscripcionInfo,
    isAdmin
}) => {
    if (!show) return null;

    return (
        <Modal
            show={show}
            onHide={onClose}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className="border-bottom-0 pb-0">
                <Modal.Title className="d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon="ban" className="text-danger" />
                    Cancelar suscripción
                </Modal.Title>
                <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={onClose} />
            </Modal.Header>

            <Modal.Body className="pt-2">
                {/* Info de la suscripción */}
                <div className="bg-light rounded p-3 mb-3 d-flex align-items-start gap-2">
                    <FontAwesomeIcon icon="info-circle" className="text-primary mt-1 flex-shrink-0" />
                    <div>
                        <p className="mb-1 text-dark fw-semibold fs--1">
                            ¿Estás seguro que deseas cancelar esta suscripción?
                        </p>
                        {suscripcionInfo && (
                            <p className="mb-0 text-muted fs--1">
                                {suscripcionInfo.vNombreSuscripcion}{' '}
                                <Badge bg="secondary" className="ms-1">#{suscripcionInfo.idSuscripcion}</Badge>
                            </p>
                        )}
                    </div>
                </div>

                {isAdmin ? (
                    <>

                        <div className="d-flex flex-column gap-2">
                            {/* Opción 1: Cancelar en Stripe + BD */}
                            <div className="border border-danger rounded p-3">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <span className="fw-semibold fs--1 text-danger d-flex align-items-center gap-1">
                                        <FontAwesomeIcon icon="times-circle" />
                                        Cancelar en Stripe y Admin Panel
                                    </span>
                                </div>
                                <p className="text-muted fs--2 mb-2">
                                    <FontAwesomeIcon icon="info-circle" className="me-1" />
                                    Detiene los cobros automáticos en Stripe y cancela la suscripción en el Admin Panel.
                                </p>
                                {processing ? (
                                    <Button variant="secondary" disabled size="sm" className="w-100">
                                        <Spinner as="span" animation="grow" size="sm" role="status" className="me-2" aria-hidden="true" />
                                        Procesando...
                                    </Button>
                                ) : (
                                    <Button onClick={() => onConfirm(true)} variant="danger" size="sm" className="w-100">
                                        <FontAwesomeIcon icon="times-circle" className="me-1" />
                                        Cancelar en Stripe y Admin Panel
                                    </Button>
                                )}
                            </div>

                            {/* Opción 2: Solo BD */}
                            <div className="border border-warning rounded p-3">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <span className="fw-semibold fs--1 text-warning d-flex align-items-center gap-1">
                                        <FontAwesomeIcon icon="database" />
                                        Cancelar solo en Admin Panel
                                    </span>
                                </div>
                                <p className="text-muted fs--2 mb-2">
                                    <FontAwesomeIcon icon="info-circle" className="me-1" />
                                    Cancela únicamente el registro en Admin Panel sin tocar Stripe.
                                </p>
                                {processing ? (
                                    <Button variant="secondary" disabled size="sm" className="w-100">
                                        <Spinner as="span" animation="grow" size="sm" role="status" className="me-2" aria-hidden="true" />
                                        Procesando...
                                    </Button>
                                ) : (
                                    <Button onClick={() => onConfirm(false)} variant="warning" size="sm" className="w-100">
                                        <FontAwesomeIcon icon="database" className="me-1" />
                                        Cancelar solo en Admin Panel
                                    </Button>
                                )}
                            </div>

                            {/* Botón cancelar */}
                            {!processing && (
                                <Button onClick={onClose} variant="outline-secondary" size="sm" className="w-100 mt-1">
                                    <FontAwesomeIcon icon="arrow-left" className="me-1" />
                                    No cancelar, volver
                                </Button>
                            )}
                        </div>
                    </>
                ) : (
                    <Row className="g-2">
                        <Col xs={6}>
                            {processing ? (
                                <Button variant="secondary" disabled className="w-100 fs--1">
                                    <Spinner as="span" animation="grow" size="sm" role="status" className="me-2" aria-hidden="true" />
                                    Procesando...
                                </Button>
                            ) : (
                                <Button onClick={() => onConfirm(true)} variant="danger" className="w-100">
                                    <FontAwesomeIcon icon="times" className="me-1" />
                                    Sí, cancelar
                                </Button>
                            )}
                        </Col>
                        <Col xs={6}>
                            {processing ? (
                                <Button variant="secondary" disabled className="w-100 fs--1">
                                    <Spinner as="span" animation="grow" size="sm" role="status" className="me-2" aria-hidden="true" />
                                    Procesando...
                                </Button>
                            ) : (
                                <Button onClick={onClose} variant="outline-secondary" className="w-100">
                                    <FontAwesomeIcon icon="arrow-left" className="me-1" />
                                    No, volver
                                </Button>
                            )}
                        </Col>
                    </Row>
                )}
            </Modal.Body>
        </Modal>
    );
};

ModalSeguroCancelarSuscripcion.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    processing: PropTypes.bool,
    suscripcionInfo: PropTypes.object,
    isAdmin: PropTypes.bool
};

export default ModalSeguroCancelarSuscripcion;
